
import { useRequiredContext } from "@ispb/react-hooks"
import { asyncified } from "@ispb/react-lazy"
import { compose } from "ramda"
import { useCallback } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { parseId } from "shared/ids"
import { ASSET_DELIMITER } from "shared/misc"
import CustomErrorPage from "ui/components/ErrorPage"
import useTitlePart from "ui/title/useTitlePart"
import { APP_NAME, IMAGE_URL, UPLOADS_URL } from "../config.js"
import { Either } from "../namespaces/Either.js"
import Boundary from "./Boundary.js"
import { PublicProcedureContext } from "./index.js"
import { printPublic } from "./print.js"

const component = compose(
    asyncified(() => {
        const procedure = useRequiredContext(PublicProcedureContext)
        return {
            passthrough: {},
            promise: useCallback(async () => {
                return {
                    data: await printPublic(procedure.data, UPLOADS_URL, IMAGE_URL, parseId)
                }
            }, [
                procedure.data
            ]),
        }
    })
)(props => {
    const pin = useRequiredContext(PublicProcedureContext)
    useTitlePart("View Procedure - " + pin.data.asset.name + ASSET_DELIMITER + pin.data.asset.location.name + " - " + APP_NAME)
    return (
        <ErrorBoundary FallbackComponent={Boundary}>
            {
                (() => {
                    if (Either.isLeft(props.data)) {
                        return <CustomErrorPage title="Rendering Error">{props.data.left}</CustomErrorPage>
                    }
                    else {
                        return <iframe className="flex-grow-1" srcDoc={props.data.right} />
                    }
                })()
            }
        </ErrorBoundary>
    )
})

export default function View(...props: Parameters<typeof component>) {
    return component(...props)
}
